import type { Vec2 } from "@arcade-hockey/sim";
import type { PerspectiveCamera } from "three/webgpu";
import { type ScreenSize, simToScreenInto } from "../render/world-mapping.js";

const PAN_SCRATCH = { x: 0, y: 0 };

/** Returns pan in [-1, 1] for an event at world position relative to camera. */
export function stereoPanFromWorld(
  worldPos: Vec2,
  camera: PerspectiveCamera,
  screen: ScreenSize,
): number {
  simToScreenInto(PAN_SCRATCH, worldPos, 0, camera, screen);
  const normalized = (PAN_SCRATCH.x - screen.width / 2) / (screen.width / 2);
  if (normalized > 1) return 1;
  if (normalized < -1) return -1;
  return normalized;
}
